// extracted by mini-css-extract-plugin
module.exports = {"ArrayData":"ArrayData_ArrayData__lm2DX"};